import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { TranslateService } from "app/modules/shared/services/translate/translate.service";
import {
  ExplorerService,
  ModalConfig,
  TransferState,
} from "app/modules/shared/services/explorer.service";
import { Subscription } from "rxjs/Subscription";
import { DynamicComponent } from "app/data/dashboard/interfaces/dynamic-component.interface";
import { SpeCodeListComponent } from "app/modules/dashboard/modules/application-params/specode/components/specode-list/specode-list.component";
import { ApiService } from "app/modules/shared/services/base/api.service";
import { findIndex, isEmpty } from "lodash";
import { ConvertIsoDateService } from "app/modules/shared/services/convert-iso-date.service";
import { KlSweetAlertService } from "app/modules/shared/services/message/kl-sweet-alert.service";
import { KlAlertService } from "app/modules/shared/services/message/alert.service";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { BehaviorSubject, of, forkJoin } from "rxjs";
import { KlDetailFilterComponent } from "@app/modules/shared/components/kl-detail-filter/kl-detail-filter.component";
import { PrimengLocal } from "@app/modules/shared/constants/primeng-local";
import { UtilService } from "@app/modules/shared/services/util.service";
import { FilterItem } from "@app/modules/shared/model/detail-filter.interface";
import { MaterialListComponent } from "@dashboard/modules/material-management/material/components/material-list/material-list.component";
import { catchError, finalize } from "rxjs/operators";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "kl-material-detail-filter",
  templateUrl: "./material-detail-filter.component.html",
  styleUrls: ["./material-detail-filter.component.scss"],
})
export class MaterialDetailFilterComponent implements OnInit, OnDestroy {
  @Input() entity;
  @Input() showSavedFilters = true;
  @Input() showBottomButtons = true;
  @ViewChild(forwardRef(() => KlDetailFilterComponent), {
    static: true,
  })
  klDetailFilterComponent: any;
  forkJoinStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  locale =
    PrimengLocal[
      localStorage.getItem("currentLanguage")
        ? localStorage.getItem("currentLanguage").toUpperCase()
        : "TR"
    ];
  tunnel: Subscription;
  entryName: string;
  currentFilter: any;
  saveForm = false;
  selectedFilterValues: Array<FilterItem> = [];
  filterList = [];
  materialCodeExpressionValue: any;
  materialDescriptionExpressionValue: any;
  materialBrandExpressionValue: any;
  materialRayonExpressionValue: any;
  materialSpecodeExpressionValue1: any;
  materialSpecodeExpressionValue2: any;
  materialSpecodeExpressionValue3: any;
  materialSpecodeExpressionValue4: any;

  alertShow = false;
  alertMessage = "";
  alertType = "";

  private _materialStatusValue: any;
  set materialStatusValue(value: any) {
    this._materialStatusValue = value;
    if (value) {
      const payload = {
        label: "material_status",
        key: "materialStatusValue",
        value: value,
        accessor: "status",
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "material_status" },
        payload
      );
    } else {
      this._materialStatusValue = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "material_status",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get materialStatusValue() {
    return this._materialStatusValue;
  }

  private _productGroupValue: any;
  set productGroupValue(value: any) {
    if (value) {
      if (value.length > 0) {
        this._productGroupValue = value;
        const payload = {
          label: "product_group",
          key: "productGroupValue",
          value: value,
          accessor: "type",
        };
        this.insertOrUpdate(
          this.selectedFilterValues,
          { label: "product_group" },
          payload
        );
      } else {
        const index = findIndex(this.selectedFilterValues, {
          label: "product_group",
        });
        if (index >= 0) {
          this.selectedFilterValues.splice(index, 1);
          this._productGroupValue = null;
        }
      }
    } else {
      this._productGroupValue = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "product_group",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get productGroupValue() {
    return this._productGroupValue;
  }

  private _packageTypeValue: any;
  set packageTypeValue(value: any) {
    if (value) {
      if (value.length > 0) {
        this._packageTypeValue = value;
        const payload = {
          label: "package_type",
          key: "packageTypeValue",
          value: value,
          accessor: "type",
        };
        this.insertOrUpdate(
          this.selectedFilterValues,
          { label: "package_type" },
          payload
        );
      } else {
        const index = findIndex(this.selectedFilterValues, {
          label: "package_type",
        });
        if (index >= 0) {
          this.selectedFilterValues.splice(index, 1);
          this._packageTypeValue = null;
        }
      }
    } else {
      this._packageTypeValue = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "package_type",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get packageTypeValue() {
    return this._packageTypeValue;
  }

  private _materialCodeValue: any;
  set materialCodeValue(value: any) {
    if (value) {
      this._materialCodeValue = value;
      const payload = {
        label: "material_code",
        key: "materialCodeValue",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "material_code" },
        payload
      );
    } else {
      const index = findIndex(this.selectedFilterValues, {
        label: "material_code",
      });
      this._materialCodeValue = null;
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get materialCodeValue() {
    return this._materialCodeValue;
  }

  private _materialDescriptionValue: any;
  set materialDescriptionValue(value: any) {
    if (value) {
      this._materialDescriptionValue = value;
      const payload = {
        label: "material_description",
        key: "materialDescriptionValue",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "material_description" },
        payload
      );
    } else {
      this._materialDescriptionValue = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "material_description",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get materialDescriptionValue() {
    return this._materialDescriptionValue;
  }

  private _materialSpeCodeValue1: any;
  set materialSpeCodeValue1(value: any) {
    if (value) {
      this._materialSpeCodeValue1 = value;
      const payload = {
        label: "material_specode",
        key: "materialSpeCodeValue1",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "material_specode" },
        payload
      );
    } else {
      this._materialSpeCodeValue1 = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "material_specode",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get materialSpeCodeValue1() {
    return this._materialSpeCodeValue1;
  }

  private _materialSpeCodeValue2: any;
  set materialSpeCodeValue2(value: any) {
    if (value) {
      this._materialSpeCodeValue2 = value;
      const payload = {
        label: "material_specode2",
        key: "materialSpeCodeValue2",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "material_specode2" },
        payload
      );
    } else {
      this._materialSpeCodeValue2 = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "material_specode2",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get materialSpeCodeValue2() {
    return this._materialSpeCodeValue2;
  }

  private _materialSpeCodeValue3: any;
  set materialSpeCodeValue3(value: any) {
    if (value) {
      this._materialSpeCodeValue3 = value;
      const payload = {
        label: "material_specode3",
        key: "materialSpeCodeValue3",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "material_specode3" },
        payload
      );
    } else {
      this._materialSpeCodeValue3 = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "material_specode3",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get materialSpeCodeValue3() {
    return this._materialSpeCodeValue3;
  }

  private _materialSpeCodeValue4: any;
  set materialSpeCodeValue4(value: any) {
    if (value) {
      this._materialSpeCodeValue4 = value;
      const payload = {
        label: "material_specode4",
        key: "materialSpeCodeValue4",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "material_specode4" },
        payload
      );
    } else {
      this._materialSpeCodeValue4 = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "material_specode4",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get materialSpeCodeValue4() {
    return this._materialSpeCodeValue4;
  }

  private _materialUserValue: any;
  set materialUserValue(value: any) {
    if (value) {
      this._materialUserValue = value;
      const payload = {
        label: "material_user",
        key: "materialUserValue",
        value: value,
        accessor: "username",
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "material_user" },
        payload
      );
    } else {
      this._materialUserValue = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "material_user",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get materialUserValue() {
    return this._materialUserValue;
  }

  private _materialLastChangedUserValue: any;
  set materialLastChangedUserValue(value: any) {
    if (value) {
      this._materialLastChangedUserValue = value;
      const payload = {
        label: "last_changed_user",
        key: "materialLastChangedUserValue",
        value: value,
        accessor: "username",
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "last_changed_user" },
        payload
      );
    } else {
      this._materialLastChangedUserValue = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "last_changed_user",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get materialLastChangedUserValue() {
    return this._materialLastChangedUserValue;
  }

  private _firstDate: Date;
  set firstDate(value: any) {
    if (value) {
      if (value instanceof Date) {
        this._firstDate = new Date(
          this.dateConvert.convertDate(value) + " 00:00:00"
        );
      } else if (typeof value === "string") {
        this._firstDate = new Date(value);
      }
      const payload = {
        label: "first_record_date",
        key: "firstDate",
        value: this._firstDate,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "first_record_date" },
        payload
      );
    } else {
      this._firstDate = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "first_record_date",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get firstDate() {
    return this._firstDate;
  }

  private _lastDate: Date;
  set lastDate(value: any) {
    if (value) {
      if (value instanceof Date) {
        this._lastDate = new Date(
          this.dateConvert.convertDate(value) + " 23:59:59"
        );
      } else if (typeof value === "string") {
        this._lastDate = new Date(value);
      }
      const payload = {
        label: "last_record_date",
        key: "lastDate",
        value: this._lastDate,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "last_record_date" },
        payload
      );
    } else {
      this._lastDate = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "last_record_date",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get lastDate() {
    return this._lastDate;
  }

  private _firstDateLastChanged: Date;
  set firstDateLastChanged(value: any) {
    if (value) {
      if (value instanceof Date) {
        this._firstDateLastChanged = new Date(
          this.dateConvert.convertDate(value) + " 00:00:00"
        );
      } else if (typeof value === "string") {
        this._firstDateLastChanged = new Date(value);
      }
      const payload = {
        label: "first_date_changed",
        key: "firstDateLastChanged",
        value: this._firstDateLastChanged,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "first_date_changed" },
        payload
      );
    } else {
      this._firstDateLastChanged = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "first_date_changed",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get firstDateLastChanged() {
    return this._firstDateLastChanged;
  }

  private _lastDateLastChanged: Date;
  set lastDateLastChanged(value: any) {
    if (value) {
      if (value instanceof Date) {
        this._lastDateLastChanged = new Date(
          this.dateConvert.convertDate(value) + " 23:59:59"
        );
      } else if (typeof value === "string") {
        this._lastDateLastChanged = new Date(value);
      }
      const payload = {
        label: "last_date_changed",
        key: "lastDateLastChanged",
        value: this._lastDateLastChanged,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "last_date_changed" },
        payload
      );
    } else {
      this._lastDateLastChanged = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "last_date_changed",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get lastDateLastChanged() {
    return this._lastDateLastChanged;
  }

  dateFormatString: string;
  materialUserOptions: any;
  MaterialSpecodeListComponent = SpeCodeListComponent;
  MaterialComponent = MaterialListComponent;
  materialStatusOptions = [
    {
      label: this.translateService.instant("ALL"),
      value: null,
    },
    {
      label: this.translateService.instant("ACTIVE"),
      value: {
        status: "ACTIVE",
      },
    },
    {
      label: this.translateService.instant("PASSIVE"),
      value: {
        status: "PASSIVE",
      },
    },
  ];
  materialExpressionOptions = [
    {
      label: this.translateService.instant("LIKE"),
      value: "LIKE",
    },
    {
      label: this.translateService.instant("NOT_LIKE"),
      value: "NOT_LIKE",
    },
    {
      label: this.translateService.instant("EQ"),
      value: "EQ",
    },
    {
      label: this.translateService.instant("NOT_EQ"),
      value: "NOT_EQ",
    },
    // {
    //   label: this.translateService.instant('IN'),
    //   value: 'IN'
    // },
    // {
    //   label: this.translateService.instant('NOT_IN'),
    //   value: 'NOT_IN'
    // },
    {
      label: this.translateService.instant("START_WITH"),
      value: "START_WITH",
    },
    {
      label: this.translateService.instant("END_WITH"),
      value: "END_WITH",
    },
    {
      label: this.translateService.instant("GT"),
      value: "GT",
    },
    {
      label: this.translateService.instant("GE"),
      value: "GE",
    },
    {
      label: this.translateService.instant("LT"),
      value: "LT",
    },
    {
      label: this.translateService.instant("LE"),
      value: "LE",
    },
  ];
  productGroupTypes = [
    {
      label: this.translateService.instant("J_RETAIL"),
      value: {
        type: "J_RETAIL",
      },
    },
    {
      label: this.translateService.instant("KL_RETAIL"),
      value: {
        type: "KL_RETAIL",
      },
    },
    {
      label: this.translateService.instant("VENUT"),
      value: {
        type: "VENUT",
      },
    },
  ];
  packageTypes = [
    {
      label: this.translateService.instant("MAIN_PACKAGE"),
      value: {
        type: "MAIN_PACKAGE",
      },
    },
    {
      label: this.translateService.instant("PLUS_USER"),
      value: {
        type: "PLUS_USER",
      },
    },
    {
      label: this.translateService.instant("ADDITION_PACKAGE"),
      value: {
        type: "ADDITION_PACKAGE",
      },
    },
  ];

  constructor(
    private explorerService: ExplorerService,
    private alertService: KlSweetAlertService,
    private klLoadingService: KlLoadingService,
    private utilService: UtilService,
    private klAlertService: KlAlertService,
    private dateConvert: ConvertIsoDateService,
    private cd: ChangeDetectorRef,
    private translateService: TranslateService,
    private apiService: ApiService
  ) {
    this.dateFormatString = UtilService.dateFormatString
      .toLowerCase()
      .replace("yy", "");
    this.tunnel = this.explorerService.transferState$.subscribe((state) => {
      switch (state.state) {
        case "MATERIAL_DETAIL_FILTER_MATERIAL_CODE_CURRENT_ITEM":
          this.materialCodeValue = state.payload.code;
          this.cd.markForCheck();
          break;
        case "MATERIAL_DETAIL_FILTER_MATERIAL_DESCRIPTION_CURRENT_ITEM":
          this.materialDescriptionValue = state.payload.description;
          this.cd.markForCheck();
          break;
        case "MATERIAL_DETAIL_FILTER_SPECODE1_CURRENT_ITEM":
          this.materialSpeCodeValue1 = state.payload.code;
          this.cd.markForCheck();
          break;
        case "MATERIAL_DETAIL_FILTER_SPECODE2_CURRENT_ITEM":
          this.materialSpeCodeValue2 = state.payload.code;
          this.cd.markForCheck();
          break;
        case "MATERIAL_DETAIL_FILTER_SPECODE3_CURRENT_ITEM":
          this.materialSpeCodeValue3 = state.payload.code;
          this.cd.markForCheck();
          break;
        case "MATERIAL_DETAIL_FILTER_SPECODE4_CURRENT_ITEM":
          this.materialSpeCodeValue4 = state.payload.code;
          this.cd.markForCheck();
          break;
      }
    });
  }

  ngOnInit() {
    this.materialCodeExpressionValue = "LIKE";
    this.materialDescriptionExpressionValue = "LIKE";
    this.materialBrandExpressionValue = "LIKE";
    this.materialRayonExpressionValue = "LIKE";
    this.materialSpecodeExpressionValue1 = "LIKE";
    this.materialSpecodeExpressionValue2 = "LIKE";
    this.materialSpecodeExpressionValue3 = "LIKE";
    this.materialSpecodeExpressionValue4 = "LIKE";
    this.klLoadingService.show("loading");
    const commitObject = {
      parent: {
        module: this.entity.parentModule,
      },
      module: this.entity.module,
      key: this.entity.state,
    };
    const preference = this.apiService
      .getFilteredData("design", commitObject)
      .pipe(catchError((error: any) => this.handleError(error)));
    const users = this.apiService
      .getAllData("user")
      .pipe(catchError((error: any) => this.handleError(error)));
    forkJoin([preference, users])
      .pipe(
        finalize(() => {
          this.klLoadingService.hide();
          if (this.entity.filter) {
            this.selectFilter({
              item: { content: JSON.stringify(this.entity.filter) },
              select: false,
            });
          }
          this.cd.markForCheck();
        })
      )
      .subscribe(
        ([preferenceResponse, userResponse]) => {
          this.materialUserOptions = userResponse;
          this.filterList = preferenceResponse.data;
          if (!this.entity.filter) {
            this.filterList.forEach((filter) => {
              if (filter.level_default === "DEFAULT") {
                this.selectFilter({ item: filter, select: true });
              }
            });
          }
          this.forkJoinStatus.next(true);
        },
        (error) => this.alertService.alertError({}, error)
      );
  }

  getFilters() {
    let commitObject = Object.create(null);
    commitObject = {
      parent: {
        module: this.entity.parentModule,
      },
      module: this.entity.module,
      key: this.entity.state,
    };
    this.apiService.getFilteredData("design", commitObject).subscribe(
      (resPreference) => {
        this.filterList = resPreference.data;
        this.cd.markForCheck();
      },
      (errPreference) => {}
    );
  }

  selectFilter(event) {
    this.clearAll();
    if (event.select) {
      this.currentFilter = event.item;
    }
    let selectObject: any;
    selectObject = JSON.parse(event.item.content);
    const filterObject = selectObject["filter"];
    const paramsObject = selectObject["parameters"];
    this.selectedFilterValues = [];
    const parametersObject = [];
    if (filterObject.hasOwnProperty("status")) {
      this.materialStatusValue = { status: filterObject["status"] };
    }
    if (filterObject.hasOwnProperty("product_groups")) {
      if (filterObject["product_groups"].length > 1) {
        const types = [];
        for (let i = 0; i < filterObject["product_groups"].length; i++) {
          types.push({ type: filterObject["product_groups"][i] });
        }
        this.productGroupValue = types;
      } else if (filterObject["product_groups"].length === 1) {
        this.productGroupValue = [{ type: filterObject["product_groups"][0] }];
      }
    }
    if (filterObject.hasOwnProperty("package_types")) {
      if (filterObject["package_types"].length > 1) {
        const types = [];
        for (let i = 0; i < filterObject["package_types"].length; i++) {
          types.push({ type: filterObject["package_types"][i] });
        }
        this.packageTypeValue = types;
      } else if (filterObject["package_types"].length === 1) {
        this.packageTypeValue = [{ type: filterObject["package_types"][0] }];
      }
    }
    if (filterObject.hasOwnProperty("code")) {
      this.materialCodeValue = filterObject["code"];
      paramsObject.forEach((params) => {
        if (params.name === "code") {
          this.materialCodeExpressionValue = params.expression["operator"];
        }
      });
      parametersObject.push({
        name: "code",
        expression: { operator: this.materialCodeExpressionValue },
      });
    }
    if (filterObject.hasOwnProperty("description")) {
      this.materialDescriptionValue = filterObject["description"];
      paramsObject.forEach((params) => {
        if (params.name === "description") {
          this.materialDescriptionExpressionValue =
            params.expression["operator"];
        }
      });
      parametersObject.push({
        name: "description",
        expression: { operator: this.materialDescriptionExpressionValue },
      });
    }
    if (filterObject.hasOwnProperty("special_code")) {
      this.materialSpeCodeValue1 = filterObject["special_code"];
      paramsObject.forEach((params) => {
        if (params.name === "special_code") {
          this.materialSpecodeExpressionValue1 = params.expression["operator"];
        }
      });
      parametersObject.push({
        name: "special_code",
        expression: { operator: this.materialSpecodeExpressionValue1 },
      });
    }
    if (filterObject.hasOwnProperty("special_code2")) {
      this.materialSpeCodeValue2 = filterObject["special_code2"];
      paramsObject.forEach((params) => {
        if (params.name === "special_code2") {
          this.materialSpecodeExpressionValue2 = params.expression["operator"];
        }
      });
      parametersObject.push({
        name: "special_code2",
        expression: { operator: this.materialSpecodeExpressionValue2 },
      });
    }
    if (filterObject.hasOwnProperty("special_code3")) {
      this.materialSpeCodeValue3 = filterObject["special_code3"];
      paramsObject.forEach((params) => {
        if (params.name === "special_code3") {
          this.materialSpecodeExpressionValue3 = params.expression["operator"];
        }
      });
      parametersObject.push({
        name: "special_code3",
        expression: { operator: this.materialSpecodeExpressionValue3 },
      });
    }
    if (filterObject.hasOwnProperty("special_code4")) {
      this.materialSpeCodeValue4 = filterObject["special_code4"];
      paramsObject.forEach((params) => {
        if (params.name === "special_code4") {
          this.materialSpecodeExpressionValue4 = params.expression["operator"];
        }
      });
      parametersObject.push({
        name: "special_code4",
        expression: { operator: this.materialSpecodeExpressionValue4 },
      });
    }
    if (filterObject.hasOwnProperty("modified_user")) {
      this.materialLastChangedUserValue = this.materialUserOptions.find(
        (user) => user.username === filterObject["modified_user"].username
      );
    }
    if (filterObject.hasOwnProperty("created_user")) {
      this.materialUserValue = this.materialUserOptions.find(
        (user) => user.username === filterObject["created_user"].username
      );
    }
    if (filterObject.hasOwnProperty("created_dates")) {
      if (filterObject["created_dates"]["min"]) {
        this.firstDate = this.dateConvert.utcDate(
          new Date(filterObject["created_dates"]["min"])
        );
      }
      if (filterObject["created_dates"]["max"]) {
        this.lastDate = this.dateConvert.utcDate(
          new Date(filterObject["created_dates"]["max"])
        );
      }
    }
    if (filterObject.hasOwnProperty("modified_dates")) {
      if (filterObject["modified_dates"]["min"]) {
        this.firstDateLastChanged = this.dateConvert.utcDate(
          new Date(filterObject["modified_dates"]["min"])
        );
      }
      if (filterObject["modified_dates"]["max"]) {
        this.lastDateLastChanged = this.dateConvert.utcDate(
          new Date(filterObject["modified_dates"]["max"])
        );
      }
    }
  }

  setModal(
    title: string,
    stateSelector: string,
    template: any,
    haveFilter = true,
    modalId
  ) {
    const modalConfig = <ModalConfig>{
      title: title,
      stateSelector: "MATERIAL_DETAIL_FILTER_" + stateSelector,
      childTemplate: <DynamicComponent>{
        mode: "DIALOG",
        modalId: modalId,
        dblSelect: true,
        template: template,
        templateContext: {
          filter: haveFilter ? { type: "MATERIAL_CARD" } : {},
        },
      },
    };
    this.explorerService.openModal(modalConfig);
  }

  deleteFromValues(event) {
    this.selectedFilterValues.splice(event.index, 1);
    this[event.item.key] = null;
  }

  deleteSavedFilter(event) {
    this.alertService.alertDelete(
      {
        title: "Uyarı",
        text: "Kayıt Silinecektir",
        customClass: "kl-alert",
        showCloseButton: false,
      },
      () => {
        this.apiService.deleteData("design", event.item.id).subscribe(
          (resDeletePreference) => {
            this.clearAll();
            this.filterList.splice(event.index, 1);
            this.cd.markForCheck();
          },
          (errDeletePreference) => {
            this.alertService.alertError({}, errDeletePreference);
          }
        );
      }
    );
  }

  clearAll() {
    delete this.currentFilter;
    for (let i = 0; i < this.selectedFilterValues.length; i++) {
      this[this.selectedFilterValues[i].key] = null;
      i = i - 1;
    }
    this.selectedFilterValues = [];
  }

  insertOrUpdate(array: any[], meta: any, value: any) {
    const index = findIndex(array, meta);
    if (index >= 0) {
      array.splice(index, 1);
      array.push(value);
      return;
    }
    return array.push(value);
  }

  commitSave(event: any) {
    this.saveForm = true;
    let commitObject = Object.create(null);
    commitObject = {
      parent: {
        module: this.entity.parentModule,
      },
      level: event.levelStatus ? "APPLICATION" : "USER",
      level_default: event.levelDesign ? "DEFAULT" : "NO_DEFAULT",
      description: event.entryName,
      module: this.entity.module,
      type: "FILTER",
      key: this.entity.state,
      content: JSON.stringify(this.prepareFilterObject()),
    };
    switch (event.commitType) {
      case "add":
        this.apiService.addData("design", commitObject).subscribe(
          (resPreference) => {
            this.saveForm = false;
            this.getFilters();
            this.selectFilter({ item: resPreference, select: true });
            this.klDetailFilterComponent.closeEntryModal();
          },
          (errPreference) => {
            this.saveForm = false;
            this.alertService.alertError({ title: "error" }, errPreference);
          }
        );
        break;
      case "edit":
        commitObject["id"] = this.currentFilter.id;
        this.apiService.updateData("design", commitObject).subscribe(
          (resPreference) => {
            this.saveForm = false;
            this.getFilters();
            this.selectFilter({ item: resPreference, select: true });
            this.klDetailFilterComponent.closeEntryModal();
          },
          (errPreference) => {
            this.saveForm = false;
            this.alertService.alertError({ title: "error" }, errPreference);
          }
        );
        break;
    }
  }

  commitFilter() {
    if (
      this.firstDate > this.lastDate ||
      this.firstDateLastChanged > this.lastDateLastChanged
    ) {
      this.alertMessage = this.translateService.instant(
        "end_date_cannot_be_less_than_start_date"
      );
      this.alertShow = true;
    } else {
      const preparedFilter: any = this.prepareFilterObject();
      if (preparedFilter.hasOwnProperty("close")) {
        delete preparedFilter.close;
      }
      if (isEmpty(preparedFilter["filter"]["modified_dates"])) {
        delete preparedFilter["filter"]["modified_dates"];
      }
      if (isEmpty(preparedFilter["filter"]["created_dates"])) {
        delete preparedFilter["filter"]["created_dates"];
      }
      const state = <TransferState>{
        state: this.entity.state,
        payload: preparedFilter,
      };
      this.explorerService.transferState(state);
      this.explorerService.closeModal(this);
    }
  }

  closeFilter() {
    const preparedFilter = this.prepareFilterObject();
    Object.assign(preparedFilter, { close: true });
    this.explorerService.transferState({
      state: this.entity.state + "_DETAIL_FILTER",
      payload: preparedFilter,
    });
    this.explorerService.closeModal(this);
  }

  prepareFilterObject() {
    const filterObject = Object.create(null);
    filterObject["modified_dates"] = Object.create(null);
    filterObject["created_dates"] = Object.create(null);
    const parametersObject = [];
    if (this.materialStatusValue) {
      filterObject["status"] = this.materialStatusValue.status;
    }
    if (this.productGroupValue) {
      filterObject["product_groups"] = this.productGroupValue.map((value) => {
        return value.type;
      });
    }
    if (this.packageTypeValue) {
      filterObject["package_types"] = this.packageTypeValue.map((value) => {
        return value.type;
      });
    }
    if (this.materialCodeValue) {
      if (this.materialCodeExpressionValue === "IN") {
        if (this.materialCodeValue.includes(";")) {
          this.materialCodeValue = this.materialCodeValue.replace(" ", "");
          const spliceCodeValue = this.materialCodeValue.split(";");
          filterObject["code"] = spliceCodeValue;
        } else {
          filterObject["code"] = [this.materialCodeValue];
        }
      } else {
        filterObject["code"] = this.materialCodeValue;
      }
      parametersObject.push({
        name: "code",
        expression: { operator: this.materialCodeExpressionValue },
      });
    }
    if (this.materialDescriptionValue) {
      filterObject["description"] = this.materialDescriptionValue;
      parametersObject.push({
        name: "description",
        expression: { operator: this.materialDescriptionExpressionValue },
      });
    }
    if (this.materialSpeCodeValue1) {
      filterObject["special_code"] = this.materialSpeCodeValue1;
      parametersObject.push({
        name: "special_code",
        expression: { operator: this.materialSpecodeExpressionValue1 },
      });
    }
    if (this.materialSpeCodeValue2) {
      filterObject["special_code2"] = this.materialSpeCodeValue2;
      parametersObject.push({
        name: "special_code2",
        expression: { operator: this.materialSpecodeExpressionValue2 },
      });
    }
    if (this.materialSpeCodeValue3) {
      filterObject["special_code3"] = this.materialSpeCodeValue3;
      parametersObject.push({
        name: "special_code3",
        expression: { operator: this.materialSpecodeExpressionValue3 },
      });
    }
    if (this.materialSpeCodeValue4) {
      filterObject["special_code4"] = this.materialSpeCodeValue4;
      parametersObject.push({
        name: "special_code4",
        expression: { operator: this.materialSpecodeExpressionValue4 },
      });
    }
    if (this.materialUserValue) {
      filterObject["created_user"] = {
        username: this.materialUserValue.username,
      };
    }
    if (this.materialLastChangedUserValue) {
      filterObject["modified_user"] = {
        username: this.materialLastChangedUserValue.username,
      };
    }
    if (this.firstDate) {
      const date = this.dateConvert.convertDate(this.firstDate);
      const newDate = new Date(date + "T00:00:01.000Z");
      filterObject["created_dates"]["min"] = newDate.getTime();
      parametersObject.push({
        name: "created_dates",
        expression: { operator: "BETWEEN" },
      });
    }
    if (this.lastDate) {
      const date = this.dateConvert.convertDate(this.lastDate);
      const newDate = new Date(date + "T23:59:59.000Z");
      filterObject["created_dates"]["max"] = newDate.getTime();
      parametersObject.push({
        name: "created_dates",
        expression: { operator: "BETWEEN" },
      });
    }
    if (this.firstDateLastChanged) {
      const date = this.dateConvert.convertDate(this.firstDateLastChanged);
      const newDate = new Date(date + "T00:00:01.000Z");
      filterObject["modified_dates"]["min"] = newDate.getTime();
      parametersObject.push({
        name: "modified_dates",
        expression: { operator: "BETWEEN" },
      });
    }
    if (this.lastDateLastChanged) {
      const date = this.dateConvert.convertDate(this.lastDateLastChanged);
      const newDate = new Date(date + "T23:59:59.000Z");
      filterObject["modified_dates"]["max"] = newDate.getTime();
      parametersObject.push({
        name: "modified_dates",
        expression: { operator: "BETWEEN" },
      });
    }
    const query = {
      paging: {
        limit: this.entity.pageSize || 10,
        offset: 0,
        fetch: "EAGER",
      },
    };
    return Object.assign(
      {},
      { filter: filterObject },
      { parameters: parametersObject },
      { query: query }
    );
  }

  handleError(error: any) {
    this.alertShow = true;
    this.alertType = "error";
    this.alertMessage = this.utilService.alertErrorMessage(error);
    this.klLoadingService.hide();
    return of(null);
  }

  ngOnDestroy() {
    this.tunnel.unsubscribe();
  }
}
